export const elevations = {
  soft: '0px 1px 4px rgba(28, 28, 33, 0.2)',
  medium:
    '0px 4px 8px 3px rgba(28, 28, 33, 0.15), 0px 1px 3px rgba(28, 28, 33, 0.3)',
  hard: '0px 8px 12px 6px rgba(28, 28, 33, 0.15), 0px 4px 4px rgba(28, 28, 33, 0.3)',
} as const;
